<template>
    <v-container fluid class="text-block">
        <h1 class="underline">Ausflug</h1>
        <p class="subtitle">Zum Schluss noch etwas Schönes 🎁</p>
        <v-row>
            <v-col cols="4" class="text-right"><b class="underline">Wo</b></v-col>
            <v-col cols="6">
                <p>Therme ⛲ <br>
                Rogner Bad Blumau</p></v-col>
        </v-row>
        <v-row>
            <v-col cols="4" class="text-right"><b class="underline">Wann</b></v-col>
            <v-col cols="6">
                <p>Bleibt dir überlassen</p>
                <p>Vorzugsweise ein langes Wochenende im Anfang 2021</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" class="text-right"><b class="underline">Wie lang</b></v-col>
            <v-col cols="6">
                <p>3 Tage ☀️<br>
                2 Nächte 🌙
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4" class="text-right"><b class="underline">Wer darf mit</b></v-col>
            <v-col cols="6"><p>Ein Partner deiner Wahl z.B. Ehemann</p>
            <p>Bei Bedarf/Wunsch ist ein Ausflug alleine auch Möglich</p></v-col>
        </v-row>
        <p>Für Babysitter ist in der Zeit gesorgt. Somit musst du dich nur um dich und möglicherweise den Partner deiner Wahl kümmern 😌</p>
    </v-container>
</template>

<script>
    import '../assets/main.css';
    export default {
        name: "Trip"
    }
</script>

<style scoped>

</style>
